<template>
    <el-scrollbar>
        <div class="view-modal window-scorll">
            <div class="icon">
                <div class="icon-title">element-ui => icon</div>
                <ul>
                    <li v-for="icon in icon_arr">
                        <i><i :class="[{'rotate_active_n':(icon === 'el-icon-refresh' || icon === 'el-icon-rank')},icon]"></i></i>
                        <span v-text="icon"></span>
                    </li>
                </ul>
                <el-button type="primary" icon="el-icon-search">搜索</el-button>
                <hr>
                <div class="icon-title">iconfont => icon</div>
                <ul>
                    <li v-for="icon in icon_arr2">
                        <i><i :class="icon"></i></i>
                        <span v-text="icon"></span>
                    </li>
                </ul>
                <hr>
                <div class="icon-title">themify => icon</div>
                <ul>
                    <li v-for="icon in icon_arr3">
                        <i><i :class="icon"></i></i>
                        <span v-text="icon"></span>
                    </li>
                </ul>
                <hr>
                <div class="icon-title">feather => icon</div>
                <ul>
                    <li v-for="icon in icon_arr4">
                        <i><i :class="icon"></i></i>
                        <span v-text="icon"></span>
                    </li>
                </ul>
            </div>
        </div>
    </el-scrollbar>
</template>
<script>
    export default{
        data() {
            return {
                icon_arr:[
                    'el-icon-edit',
                    'el-icon-share',
                    'el-icon-delete',
                    'el-icon-info',
                    'el-icon-error',
                    'el-icon-success',
                    'el-icon-warning',
                    'el-icon-question',
                    'el-icon-back',
                    'el-icon-arrow-left',
                    'el-icon-arrow-down',
                    'el-icon-arrow-right',
                    'el-icon-arrow-up',
                    'el-icon-caret-left',
                    'el-icon-caret-bottom',
                    'el-icon-caret-top',
                    'el-icon-caret-right',
                    'el-icon-d-arrow-left',
                    'el-icon-d-arrow-right',
                    'el-icon-minus',
                    'el-icon-plus',
                    'el-icon-remove',
                    'el-icon-circle-plus',
                    'el-icon-remove-outline',
                    'el-icon-circle-plus-outline',
                    'el-icon-close',
                    'el-icon-check',
                    'el-icon-circle-close',
                    'el-icon-circle-check',
                    'el-icon-circle-close-outline',
                    'el-icon-circle-check-outline',
                    'el-icon-zoom-out',
                    'el-icon-zoom-in',
                    'el-icon-d-caret',
                    'el-icon-sort',
                    'el-icon-sort-down',
                    'el-icon-sort-up',
                    'el-icon-tickets',
                    'el-icon-document',
                    'el-icon-goods',
                    'el-icon-sold-out',
                    'el-icon-news',
                    'el-icon-message',
                    'el-icon-date',
                    'el-icon-printer',
                    'el-icon-time',
                    'el-icon-bell',
                    'el-icon-mobile-phone',
                    'el-icon-service',
                    'el-icon-view',
                    'el-icon-menu',
                    'el-icon-more',
                    'el-icon-more-outline',
                    'el-icon-star-on',
                    'el-icon-star-off',
                    'el-icon-location',
                    'el-icon-location-outline',
                    'el-icon-phone',
                    'el-icon-phone-outline',
                    'el-icon-picture',
                    'el-icon-picture-outline',
                    'el-icon-delete',
                    'el-icon-search',
                    'el-icon-edit',
                    'el-icon-edit-outline',
                    'el-icon-rank',
                    'el-icon-refresh',
                    'el-icon-share',
                    'el-icon-setting',
                    'el-icon-upload',
                    'el-icon-upload2',
                    'el-icon-download',
                    'el-icon-loading'
                ],
                icon_arr2:[
                    'ico-home',
                    'ico-home2',
                    'ico-home3',
                    'ico-home4',
                    'ico-home5',
                    'ico-home6',
                    'ico-home7',
                    'ico-home8',
                    'ico-home9',
                    'ico-home10',
                    'ico-home11',
                    'ico-office',
                    'ico-newspaper',
                    'ico-pencil',
                    'ico-pencil2',
                    'ico-pencil3',
                    'ico-pencil4',
                    'ico-pencil5',
                    'ico-pencil6',
                    'ico-quill',
                    'ico-quill2',
                    'ico-quill3',
                    'ico-pen',
                    'ico-pen2',
                    'ico-pen3',
                    'ico-pen4',
                    'ico-pen5',
                    'ico-marker',
                    'ico-home12',
                    'ico-marker2',
                    'ico-blog',
                    'ico-blog2',
                    'ico-brush',
                    'ico-palette',
                    'ico-palette2',
                    'ico-eyedropper',
                    'ico-eyedropper2',
                    'ico-droplet',
                    'ico-droplet2',
                    'ico-droplet3',
                    'ico-droplet4',
                    'ico-paint-format',
                    'ico-paint-format2',
                    'ico-image',
                    'ico-image2',
                    'ico-image3',
                    'ico-images',
                    'ico-image4',
                    'ico-image5',
                    'ico-image6',
                    'ico-images2',
                    'ico-image7',
                    'ico-camera',
                    'ico-camera2',
                    'ico-camera3',
                    'ico-camera4',
                    'ico-music',
                    'ico-music2',
                    'ico-music3',
                    'ico-music4',
                    'ico-music5',
                    'ico-music6',
                    'ico-piano',
                    'ico-guitar',
                    'ico-headphones',
                    'ico-headphones2',
                    'ico-play',
                    'ico-play2',
                    'ico-movie',
                    'ico-movie2',
                    'ico-movie3',
                    'ico-film',
                    'ico-film2',
                    'ico-film3',
                    'ico-film4',
                    'ico-camera5',
                    'ico-camera6',
                    'ico-camera7',
                    'ico-camera8',
                    'ico-camera9',
                    'ico-dice',
                    'ico-gamepad',
                    'ico-gamepad2',
                    'ico-gamepad3',
                    'ico-pacman',
                    'ico-spades',
                    'ico-clubs',
                    'ico-diamonds',
                    'ico-king',
                    'ico-queen',
                    'ico-rock',
                    'ico-bishop',
                    'ico-knight',
                    'ico-pawn',
                    'ico-chess',
                    'ico-bullhorn',
                    'ico-megaphone',
                    'ico-new',
                    'ico-connection',
                    'ico-connection2',
                    'ico-podcast',
                    'ico-radio',
                    'ico-feed',
                    'ico-connection3',
                    'ico-radio2',
                    'ico-podcast2',
                    'ico-podcast3',
                    'ico-mic',
                    'ico-mic2',
                    'ico-mic3',
                    'ico-mic4',
                    'ico-mic5',
                    'ico-book',
                    'ico-book2',
                    'ico-books',
                    'ico-reading',
                    'ico-library',
                    'ico-library2',
                    'ico-graduation',
                    'ico-file',
                    'ico-profile',
                    'ico-file2',
                    'ico-file3',
                    'ico-file4',
                    'ico-file5',
                    'ico-file6',
                    'ico-files',
                    'ico-file-plus',
                    'ico-file-minus',
                    'ico-file-download',
                    'ico-file-upload',
                    'ico-file-check',
                    'ico-file-remove',
                    'ico-file7',
                    'ico-file8',
                    'ico-file-plus2',
                    'ico-file-minus2',
                    'ico-file-download2',
                    'ico-file-upload2',
                    'ico-file-check2',
                    'ico-file-remove2',
                    'ico-file9',
                    'ico-copy',
                    'ico-copy2',
                    'ico-copy3',
                    'ico-copy4',
                    'ico-paste',
                    'ico-paste2',
                    'ico-paste3',
                    'ico-stack',
                    'ico-stack2',
                    'ico-stack3',
                    'ico-folder',
                    'ico-folder-download',
                    'ico-folder-upload',
                    'ico-folder-plus',
                    'ico-folder-plus2',
                    'ico-folder-minus',
                    'ico-folder-minus2',
                    'ico-folder8',
                    'ico-folder-remove',
                    'ico-folder2',
                    'ico-folder-open',
                    'ico-folder3',
                    'ico-folder4',
                    'ico-folder-plus3',
                    'ico-folder-minus3',
                    'ico-folder-plus4',
                    'ico-folder-remove2',
                    'ico-folder-download2',
                    'ico-folder-upload2',
                    'ico-folder-download3',
                    'ico-folder-upload3',
                    'ico-folder5',
                    'ico-folder-open2',
                    'ico-folder6',
                    'ico-folder-open3',
                    'ico-certificate',
                    'ico-cc',
                    'ico-tag',
                    'ico-tag2',
                    'ico-tag3',
                    'ico-tag4',
                    'ico-tag5',
                    'ico-tag6',
                    'ico-tag7',
                    'ico-tags',
                    'ico-tags2',
                    'ico-tag8',
                    'ico-barcode',
                    'ico-barcode2',
                    'ico-qrcode',
                    'ico-ticket',
                    'ico-cart',
                    'ico-cart2',
                    'ico-cart3',
                    'ico-cart4',
                    'ico-cart5',
                    'ico-cart6',
                    'ico-cart7',
                    'ico-cart-plus',
                    'ico-cart-minus',
                    'ico-cart-add',
                    'ico-cart-remove',
                    'ico-cart-checkout',
                    'ico-cart-remove2',
                    'ico-basket',
                    'ico-basket2',
                    'ico-bag',
                    'ico-bag2',
                    'ico-bag3',
                    'ico-coin',
                    'ico-coins',
                    'ico-credit',
                    'ico-credit2',
                    'ico-calculate',
                    'ico-calculate2',
                    'ico-support',
                    'ico-phone',
                    'ico-phone2',
                    'ico-phone3',
                    'ico-phone4',
                    'ico-contact-add',
                    'ico-contact-remove',
                    'ico-contact-add2',
                    'ico-contact-remove2',
                    'ico-call-incoming',
                    'ico-call-outgoing',
                    'ico-phone5',
                    'ico-phone6',
                    'ico-phone-hang-up',
                    'ico-phone-hang-up2',
                    'ico-address-book',
                    'ico-address-book2',
                    'ico-notebook',
                    'ico-envelop',
                    'ico-envelop2',
                    'ico-mail-send',
                    'ico-envelop-opened',
                    'ico-envelop3',
                    'ico-pushpin',
                    'ico-location',
                    'ico-location2',
                    'ico-location3',
                    'ico-location4',
                    'ico-location5',
                    'ico-location6',
                    'ico-location7',
                    'ico-compass',
                    'ico-compass2',
                    'ico-map',
                    'ico-map2',
                    'ico-map3',
                    'ico-map4',
                    'ico-direction',
                    'ico-history',
                    'ico-history2',
                    'ico-clock',
                    'ico-clock2',
                    'ico-clock3',
                    'ico-clock4',
                    'ico-watch',
                    'ico-clock5',
                    'ico-clock6',
                    'ico-clock7',
                    'ico-alarm',
                    'ico-alarm2',
                    'ico-bell',
                    'ico-bell2',
                    'ico-alarm-plus',
                    'ico-alarm-minus',
                    'ico-alarm-check',
                    'ico-alarm-cancel',
                    'ico-stopwatch',
                    'ico-calendar',
                    'ico-calendar2',
                    'ico-calendar3',
                    'ico-calendar4',
                    'ico-calendar5',
                    'ico-print',
                    'ico-print2',
                    'ico-print3',
                    'ico-mouse',
                    'ico-mouse2',
                    'ico-mouse3',
                    'ico-mouse4',
                    'ico-keyboard',
                    'ico-keyboard2',
                    'ico-screen',
                    'ico-screen2',
                    'ico-screen3',
                    'ico-screen4',
                    'ico-laptop',
                    'ico-mobile',
                    'ico-mobile2',
                    'ico-tablet',
                    'ico-mobile3',
                    'ico-tv',
                    'ico-cabinet',
                    'ico-archive',
                    'ico-drawer',
                    'ico-drawer2',
                    'ico-drawer3',
                    'ico-box',
                    'ico-box-add',
                    'ico-box-remove',
                    'ico-download',
                    'ico-upload',
                    'ico-disk',
                    'ico-cd',
                    'ico-storage',
                    'ico-storage2',
                    'ico-database',
                    'ico-database2',
                    'ico-database3',
                    'ico-undo',
                    'ico-redo',
                    'ico-rotate',
                    'ico-rotate2',
                    'ico-flip',
                    'ico-flip2',
                    'ico-unite',
                    'ico-subtract',
                    'ico-interset',
                    'ico-exclude',
                    'ico-align-left',
                    'ico-align-center-horizontal',
                    'ico-align-right',
                    'ico-align-top',
                    'ico-align-center-vertical',
                    'ico-align-bottom',
                    'ico-undo2',
                    'ico-redo2',
                    'ico-forward',
                    'ico-reply',
                    'ico-reply2',
                    'ico-bubble',
                    'ico-bubbles',
                    'ico-bubbles2',
                    'ico-bubble2',
                    'ico-bubbles3',
                    'ico-bubbles4',
                    'ico-bubble-notification',
                    'ico-bubbles5',
                    'ico-bubbles6',
                    'ico-bubble3',
                    'ico-bubble-dots',
                    'ico-bubble4',
                    'ico-bubble5',
                    'ico-bubble-dots2',
                    'ico-bubble6',
                    'ico-bubble7',
                    'ico-bubble8',
                    'ico-bubbles7',
                    'ico-bubble9',
                    'ico-bubbles8',
                    'ico-bubble10',
                    'ico-bubble-dots3',
                    'ico-bubble11',
                    'ico-bubble12',
                    'ico-bubble-dots4',
                    'ico-glass',
                    'ico-bubble13',
                    'ico-music7',
                    'ico-bubbles9',
                    'ico-search',
                    'ico-bubbles10',
                    'ico-envelope',
                    'ico-heart',
                    'ico-bubble-blocked',
                    'ico-star',
                    'ico-bubble-quote',
                    'ico-star-empty',
                    'ico-bubble-user',
                    'ico-bubble-check',
                    'ico-user',
                    'ico-bubble-video-chat',
                    'ico-film5',
                    'ico-bubble-link',
                    'ico-th-large',
                    'ico-th',
                    'ico-bubble-locked',
                    'ico-th-list',
                    'ico-bubble-star',
                    'ico-ok',
                    'ico-bubble-heart',
                    'ico-remove',
                    'ico-bubble-paperclip',
                    'ico-zoom-in',
                    'ico-bubble-cancel',
                    'ico-zoom-out',
                    'ico-bubble-plus',
                    'ico-off',
                    'ico-bubble-minus',
                    'ico-signal',
                    'ico-bubble-notification2',
                    'ico-cog',
                    'ico-bubble-trash',
                    'ico-bubble-left',
                    'ico-trash',
                    'ico-bubble-right',
                    'ico-home13',
                    'ico-bubble-up',
                    'ico-file10',
                    'ico-bubble-down',
                    'ico-time',
                    'ico-road',
                    'ico-bubble-first',
                    'ico-bubble-last',
                    'ico-download-alt',
                    'ico-bubble-replu',
                    'ico-download2',
                    'ico-bubble-forward',
                    'ico-upload2',
                    'ico-bubble-reply',
                    'ico-inbox',
                    'ico-bubble-forward2',
                    'ico-play-circle',
                    'ico-repeat',
                    'ico-user2',
                    'ico-refresh',
                    'ico-users',
                    'ico-list-alt',
                    'ico-user-plus',
                    'ico-lock',
                    'ico-user-plus2',
                    'ico-flag',
                    'ico-user-minus',
                    'ico-user-minus2',
                    'ico-headphones3',
                    'ico-user-cancel',
                    'ico-volume-off',
                    'ico-user-block',
                    'ico-volume-down',
                    'ico-volume-up',
                    'ico-users2',
                    'ico-qrcode2',
                    'ico-user22',
                    'ico-barcode3',
                    'ico-users3',
                    'ico-user-plus3',
                    'ico-tag9',
                    'ico-user-minus3',
                    'ico-tags3',
                    'ico-book3',
                    'ico-user-cancel2',
                    'ico-bookmark',
                    'ico-user-block2',
                    'ico-user3',
                    'ico-print4',
                    'ico-camera10',
                    'ico-user4',
                    'ico-font',
                    'ico-user5',
                    'ico-user6',
                    'ico-bold',
                    'ico-users4',
                    'ico-italic',
                    'ico-user7',
                    'ico-text-height',
                    'ico-text-width',
                    'ico-user8',
                    'ico-align-left2',
                    'ico-users5',
                    'ico-align-center',
                    'ico-vcard',
                    'ico-tshirt',
                    'ico-align-right2',
                    'ico-align-justify',
                    'ico-hanger',
                    'ico-quotes-left',
                    'ico-list',
                    'ico-quotes-right',
                    'ico-indent-left',
                    'ico-quotes-right2',
                    'ico-indent-right',
                    'ico-quotes-right3',
                    'ico-facetime-video',
                    'ico-busy',
                    'ico-picture',
                    'ico-busy2',
                    'ico-pencil7',
                    'ico-map-marker',
                    'ico-busy3',
                    'ico-adjust',
                    'ico-busy4',
                    'ico-tint',
                    'ico-spinner',
                    'ico-spinner2',
                    'ico-edit',
                    'ico-spinner3',
                    'ico-share',
                    'ico-spinner4',
                    'ico-check',
                    'ico-spinner5',
                    'ico-move',
                    'ico-spinner6',
                    'ico-step-backward',
                    'ico-spinner7',
                    'ico-fast-backward',
                    'ico-spinner8',
                    'ico-backward',
                    'ico-play3',
                    'ico-spinner9',
                    'ico-pause',
                    'ico-spinner10',
                    'ico-spinner11',
                    'ico-stop',
                    'ico-spinner12',
                    'ico-forward2',
                    'ico-microscope',
                    'ico-fast-forward',
                    'ico-step-forward',
                    'ico-binoculars',
                    'ico-binoculars2',
                    'ico-eject',
                    'ico-search2',
                    'ico-chevron-left',
                    'ico-search22',
                    'ico-chevron-right',
                    'ico-zoom-in2',
                    'ico-plus-sign',
                    'ico-zoom-out2',
                    'ico-minus-sign',
                    'ico-search3',
                    'ico-remove-sign',
                    'ico-ok-sign',
                    'ico-search4',
                    'ico-question-sign',
                    'ico-zoom-in22',
                    'ico-info-sign',
                    'ico-zoom-out22',
                    'ico-screenshot',
                    'ico-search5',
                    'ico-expand',
                    'ico-remove-circle',
                    'ico-contract',
                    'ico-ok-circle',
                    'ico-ban-circle',
                    'ico-scale-up',
                    'ico-arrow-left',
                    'ico-scale-down',
                    'ico-arrow-right',
                    'ico-expand2',
                    'ico-contract2',
                    'ico-arrow-up',
                    'ico-arrow-down',
                    'ico-scale-up2',
                    'ico-scale-down2',
                    'ico-share-alt',
                    'ico-fullscreen',
                    'ico-resize-full',
                    'ico-expand3',
                    'ico-resize-small',
                    'ico-contract3',
                    'ico-plus',
                    'ico-key',
                    'ico-minus',
                    'ico-asterisk',
                    'ico-key2',
                    'ico-exclamation-sign',
                    'ico-key3',
                    'ico-key4',
                    'ico-gift',
                    'ico-leaf',
                    'ico-key5',
                    'ico-fire',
                    'ico-keyhole',
                    'ico-eye-open',
                    'ico-lock2',
                    'ico-eye-close',
                    'ico-lock22',
                    'ico-warning-sign',
                    'ico-lock3',
                    'ico-plane',
                    'ico-lock4',
                    'ico-unlocked',
                    'ico-calendar6',
                    'ico-lock5',
                    'ico-random',
                    'ico-unlocked2',
                    'ico-comment',
                    'ico-wrench',
                    'ico-magnet',
                    'ico-wrench2',
                    'ico-chevron-up',
                    'ico-chevron-down',
                    'ico-wrench3',
                    'ico-wrench4',
                    'ico-retweet',
                    'ico-settings',
                    'ico-shopping-cart',
                    'ico-equalizer',
                    'ico-folder-close',
                    'ico-equalizer2',
                    'ico-folder-open4',
                    'ico-equalizer3',
                    'ico-resize-vertical',
                    'ico-resize-horizontal',
                    'ico-cog2',
                    'ico-bar-chart',
                    'ico-cogs',
                    'ico-cog22',
                    'ico-twitter-sign',
                    'ico-facebook-sign',
                    'ico-cog3',
                    'ico-camera-retro',
                    'ico-cog4',
                    'ico-key6',
                    'ico-cog5',
                    'ico-cog6',
                    'ico-cogs2',
                    'ico-cog7',
                    'ico-comments',
                    'ico-factory',
                    'ico-thumbs-up',
                    'ico-thumbs-down',
                    'ico-hammer',
                    'ico-tools',
                    'ico-star-half',
                    'ico-screwdriver',
                    'ico-heart-empty',
                    'ico-screwdriver2',
                    'ico-signout',
                    'ico-wand',
                    'ico-linkedin-sign',
                    'ico-wand2',
                    'ico-pushpin2',
                    'ico-external-link',
                    'ico-health',
                    'ico-signin',
                    'ico-aid',
                    'ico-trophy',
                    'ico-patch',
                    'ico-github-sign',
                    'ico-bug',
                    'ico-upload-alt',
                    'ico-bug2',
                    'ico-inject',
                    'ico-lemon',
                    'ico-inject2',
                    'ico-phone7',
                    'ico-construction',
                    'ico-check-empty',
                    'ico-cone',
                    'ico-bookmark-empty',
                    'ico-pie',
                    'ico-phone-sign',
                    'ico-twitter',
                    'ico-pie2',
                    'ico-pie3',
                    'ico-facebook',
                    'ico-pie4',
                    'ico-github',
                    'ico-pie5',
                    'ico-unlock',
                    'ico-credit3',
                    'ico-pie6',
                    'ico-rss',
                    'ico-pie7',
                    'ico-hdd',
                    'ico-stats',
                    'ico-stats2',
                    'ico-bullhorn2',
                    'ico-bell3',
                    'ico-stats3',
                    'ico-certificate2',
                    'ico-bars',
                    'ico-hand-right',
                    'ico-bars2',
                    'ico-hand-left',
                    'ico-bars3',
                    'ico-bars4',
                    'ico-hand-up',
                    'ico-bars5',
                    'ico-hand-down',
                    'ico-bars6',
                    'ico-circle-arrow-left',
                    'ico-stats-up',
                    'ico-circle-arrow-right',
                    'ico-stats-down',
                    'ico-circle-arrow-up',
                    'ico-stairs-down',
                    'ico-circle-arrow-down',
                    'ico-globe',
                    'ico-stairs-down2',
                    'ico-chart',
                    'ico-wrench5',
                    'ico-tasks',
                    'ico-stairs',
                    'ico-filter',
                    'ico-stairs2',
                    'ico-ladder',
                    'ico-briefcase',
                    'ico-fullscreen2',
                    'ico-cake',
                    'ico-group',
                    'ico-gift2',
                    'ico-link',
                    'ico-gift22',
                    'ico-balloon',
                    'ico-cloud',
                    'ico-beaker',
                    'ico-rating',
                    'ico-cut',
                    'ico-rating2',
                    'ico-copy5',
                    'ico-rating3',
                    'ico-paper-clip',
                    'ico-podium',
                    'ico-medal',
                    'ico-save',
                    'ico-medal2',
                    'ico-sign-blank',
                    'ico-reorder',
                    'ico-medal3',
                    'ico-list-ul',
                    'ico-medal4',
                    'ico-medal5',
                    'ico-list-ol',
                    'ico-strikethrough',
                    'ico-crown',
                    'ico-trophy2',
                    'ico-underline',
                    'ico-trophy22',
                    'ico-table',
                    'ico-magic',
                    'ico-trophy-star',
                    'ico-truck',
                    'ico-diamond',
                    'ico-diamond2',
                    'ico-pinterest',
                    'ico-glass2',
                    'ico-pinterest-sign',
                    'ico-google-plus-sign',
                    'ico-glass22',
                    'ico-bottle',
                    'ico-google-plus',
                    'ico-bottle2',
                    'ico-money',
                    'ico-caret-down',
                    'ico-mug',
                    'ico-food',
                    'ico-caret-up',
                    'ico-caret-left',
                    'ico-food2',
                    'ico-caret-right',
                    'ico-hamburger',
                    'ico-cup',
                    'ico-columns',
                    'ico-sort',
                    'ico-cup2',
                    'ico-sort-down',
                    'ico-leaf2',
                    'ico-leaf22',
                    'ico-sort-up',
                    'ico-envelope-alt',
                    'ico-apple-fruit',
                    'ico-linkedin',
                    'ico-tree',
                    'ico-undo3',
                    'ico-tree2',
                    'ico-legal',
                    'ico-paw',
                    'ico-dashboard',
                    'ico-steps',
                    'ico-flower',
                    'ico-comment-alt',
                    'ico-comments-alt',
                    'ico-rocket',
                    'ico-meter',
                    'ico-bolt',
                    'ico-sitemap',
                    'ico-meter2',
                    'ico-meter-slow',
                    'ico-umbrella',
                    'ico-paste4',
                    'ico-meter-medium',
                    'ico-meter-fast',
                    'ico-lightbulb',
                    'ico-exchange',
                    'ico-dashboard2',
                    'ico-cloud-download',
                    'ico-hammer2',
                    'ico-balance',
                    'ico-cloud-upload',
                    'ico-user-md',
                    'ico-bomb',
                    'ico-stethoscope',
                    'ico-fire2',
                    'ico-suitcase',
                    'ico-fire22',
                    'ico-bell-alt',
                    'ico-lab',
                    'ico-coffee',
                    'ico-atom',
                    'ico-atom2',
                    'ico-food3',
                    'ico-magnet2',
                    'ico-file-alt',
                    'ico-magnet22',
                    'ico-building',
                    'ico-magnet3',
                    'ico-hospital',
                    'ico-magnet4',
                    'ico-ambulance',
                    'ico-dumbbell',
                    'ico-medkit',
                    'ico-skull',
                    'ico-fighter-jet',
                    'ico-skull2',
                    'ico-beer',
                    'ico-h-sign',
                    'ico-skull3',
                    'ico-plus-sign2',
                    'ico-lamp',
                    'ico-lamp2',
                    'ico-double-angle-left',
                    'ico-double-angle-right',
                    'ico-lamp3',
                    'ico-double-angle-up',
                    'ico-lamp4',
                    'ico-double-angle-down',
                    'ico-remove2',
                    'ico-angle-left',
                    'ico-remove22',
                    'ico-remove3',
                    'ico-angle-right',
                    'ico-remove4',
                    'ico-angle-up',
                    'ico-angle-down',
                    'ico-remove5',
                    'ico-desktop',
                    'ico-remove6',
                    'ico-laptop2',
                    'ico-remove7',
                    'ico-tablet2',
                    'ico-remove8',
                    'ico-briefcase2',
                    'ico-mobile4',
                    'ico-circle-blank',
                    'ico-briefcase22',
                    'ico-quote-left',
                    'ico-briefcase3',
                    'ico-quote-right',
                    'ico-airplane',
                    'ico-airplane2',
                    'ico-spinner13',
                    'ico-circle',
                    'ico-paper-plane',
                    'ico-car',
                    'ico-reply3',
                    'ico-github-alt',
                    'ico-gas-pump',
                    'ico-bus',
                    'ico-folder-close-alt',
                    'ico-folder-open-alt',
                    'ico-truck2',
                    'ico-bike',
                    'ico-expand-alt',
                    'ico-road2',
                    'ico-collapse-alt',
                    'ico-smile',
                    'ico-train',
                    'ico-ship',
                    'ico-frown',
                    'ico-meh',
                    'ico-boat',
                    'ico-cube',
                    'ico-gamepad4',
                    'ico-cube2',
                    'ico-keyboard3',
                    'ico-cube3',
                    'ico-flag-alt',
                    'ico-cube4',
                    'ico-flag-checkered',
                    'ico-pyramid',
                    'ico-terminal',
                    'ico-code',
                    'ico-pyramid2',
                    'ico-reply-all',
                    'ico-cylinder',
                    'ico-star-half-full',
                    'ico-package',
                    'ico-puzzle',
                    'ico-location-arrow',
                    'ico-crop',
                    'ico-puzzle2',
                    'ico-code-fork',
                    'ico-puzzle3',
                    'ico-unlink',
                    'ico-puzzle4',
                    'ico-glasses',
                    'ico-question',
                    'ico-info',
                    'ico-glasses2',
                    'ico-exclamation',
                    'ico-glasses3',
                    'ico-superscript',
                    'ico-sun-glasses',
                    'ico-accessibility',
                    'ico-subscript',
                    'ico-accessibility2',
                    'ico-eraser',
                    'ico-puzzle5',
                    'ico-brain',
                    'ico-microphone',
                    'ico-target',
                    'ico-target2',
                    'ico-microphone-off',
                    'ico-target3',
                    'ico-shield',
                    'ico-gun',
                    'ico-calendar-empty',
                    'ico-gun-ban',
                    'ico-fire-extinguisher',
                    'ico-shield2',
                    'ico-rocket2',
                    'ico-shield22',
                    'ico-maxcdn',
                    'ico-shield3',
                    'ico-chevron-sign-left',
                    'ico-shield4',
                    'ico-chevron-sign-right',
                    'ico-chevron-sign-up',
                    'ico-soccer',
                    'ico-football',
                    'ico-chevron-sign-down',
                    'ico-baseball',
                    'ico-html5',
                    'ico-basketball',
                    'ico-css3',
                    'ico-golf',
                    'ico-anchor',
                    'ico-hockey',
                    'ico-unlock-alt',
                    'ico-racing',
                    'ico-bullseye',
                    'ico-eight-ball',
                    'ico-ellipsis-horizontal',
                    'ico-ellipsis-vertical',
                    'ico-bowling-ball',
                    'ico-bowling',
                    'ico-rss-sign',
                    'ico-play-sign',
                    'ico-bowling2',
                    'ico-lightning',
                    'ico-ticket2',
                    'ico-power',
                    'ico-minus-sign-alt',
                    'ico-power2',
                    'ico-check-minus',
                    'ico-switch',
                    'ico-level-up',
                    'ico-power-cord',
                    'ico-level-down',
                    'ico-cord',
                    'ico-check-sign',
                    'ico-socket',
                    'ico-edit-sign',
                    'ico-clipboard',
                    'ico-external-link-sign',
                    'ico-clipboard2',
                    'ico-share-sign',
                    'ico-signup',
                    'ico-compass3',
                    'ico-clipboard3',
                    'ico-collapse',
                    'ico-clipboard4',
                    'ico-collapse-top',
                    'ico-list2',
                    'ico-expand4',
                    'ico-list22',
                    'ico-euro',
                    'ico-list3',
                    'ico-gbp',
                    'ico-numbered-list',
                    'ico-dollar',
                    'ico-rupee',
                    'ico-list4',
                    'ico-yen',
                    'ico-list5',
                    'ico-renminbi',
                    'ico-playlist',
                    'ico-grid',
                    'ico-won',
                    'ico-bitcoin',
                    'ico-grid2',
                    'ico-grid3',
                    'ico-file11',
                    'ico-grid4',
                    'ico-file-text',
                    'ico-grid5',
                    'ico-sort-by-alphabet',
                    'ico-sort-by-alphabet-alt',
                    'ico-grid6',
                    'ico-sort-by-attributes',
                    'ico-tree3',
                    'ico-sort-by-attributes-alt',
                    'ico-tree4',
                    'ico-sort-by-order',
                    'ico-tree5',
                    'ico-sort-by-order-alt',
                    'ico-menu',
                    'ico-thumbs-up2',
                    'ico-menu2',
                    'ico-thumbs-down2',
                    'ico-circle-small',
                    'ico-menu3',
                    'ico-youtube-sign',
                    'ico-menu4',
                    'ico-youtube',
                    'ico-xing',
                    'ico-menu5',
                    'ico-menu6',
                    'ico-xing-sign',
                    'ico-youtube-play',
                    'ico-menu7',
                    'ico-menu8',
                    'ico-dropbox',
                    'ico-stackexchange',
                    'ico-menu9',
                    'ico-instagram',
                    'ico-cloud2',
                    'ico-flickr',
                    'ico-cloud22',
                    'ico-cloud3',
                    'ico-adn',
                    'ico-cloud-download2',
                    'ico-bitbucket',
                    'ico-cloud-upload2',
                    'ico-bitbucket-sign',
                    'ico-tumblr',
                    'ico-download22',
                    'ico-tumblr-sign',
                    'ico-upload22',
                    'ico-long-arrow-down',
                    'ico-download3',
                    'ico-long-arrow-up',
                    'ico-upload3',
                    'ico-download4',
                    'ico-long-arrow-left',
                    'ico-upload4',
                    'ico-long-arrow-right',
                    'ico-download5',
                    'ico-apple',
                    'ico-upload5',
                    'ico-windows',
                    'ico-download6',
                    'ico-android',
                    'ico-upload6',
                    'ico-linux',
                    'ico-download7',
                    'ico-dribbble',
                    'ico-upload7',
                    'ico-skype',
                    'ico-globe2',
                    'ico-foursquare',
                    'ico-globe22',
                    'ico-trello',
                    'ico-globe3',
                    'ico-female',
                    'ico-earth',
                    'ico-male',
                    'ico-network',
                    'ico-gittip',
                    'ico-link2',
                    'ico-sun',
                    'ico-link22',
                    'ico-moon',
                    'ico-archive2',
                    'ico-link3',
                    'ico-bug3',
                    'ico-link222',
                    'ico-vk',
                    'ico-link4',
                    'ico-weibo',
                    'ico-link5',
                    'ico-link6',
                    'ico-renren',
                    'ico-anchor2',
                    'ico-flag2',
                    'ico-flag22',
                    'ico-flag3',
                    'ico-flag4',
                    'ico-flag5',
                    'ico-flag6',
                    'ico-attachment',
                    'ico-attachment2',
                    'ico-eye',
                    'ico-eye-blocked',
                    'ico-eye2',
                    'ico-eye3',
                    'ico-eye-blocked2',
                    'ico-eye4',
                    'ico-eye5',
                    'ico-eye6',
                    'ico-eye7',
                    'ico-eye8',
                    'ico-bookmark2',
                    'ico-bookmark22',
                    'ico-bookmarks',
                    'ico-bookmark3',
                    'ico-spotlight',
                    'ico-starburst',
                    'ico-snowflake',
                    'ico-temperature',
                    'ico-temperature2',
                    'ico-weather-lightning',
                    'ico-weather-rain',
                    'ico-weather-snow',
                    'ico-windy',
                    'ico-fan',
                    'ico-umbrella2',
                    'ico-sun2',
                    'ico-sun22',
                    'ico-brightness-high',
                    'ico-brightness-medium',
                    'ico-brightness-low',
                    'ico-brightness-contrast',
                    'ico-contrast',
                    'ico-moon2',
                    'ico-bed',
                    'ico-bed2',
                    'ico-star2',
                    'ico-star22',
                    'ico-star3',
                    'ico-star4',
                    'ico-star5',
                    'ico-star6',
                    'ico-heart2',
                    'ico-heart22',
                    'ico-heart3',
                    'ico-heart4',
                    'ico-heart-broken',
                    'ico-heart5',
                    'ico-heart6',
                    'ico-heart-broken2',
                    'ico-heart7',
                    'ico-heart8',
                    'ico-heart-broken3',
                    'ico-lips',
                    'ico-lips2',
                    'ico-thumbs-up3',
                    'ico-thumbs-up22',
                    'ico-thumbs-down3',
                    'ico-thumbs-down22',
                    'ico-thumbs-up32',
                    'ico-thumbs-up4',
                    'ico-thumbs-up5',
                    'ico-thumbs-up6',
                    'ico-people',
                    'ico-man',
                    'ico-male2',
                    'ico-woman',
                    'ico-female2',
                    'ico-peace',
                    'ico-yin-yang',
                    'ico-happy',
                    'ico-happy2',
                    'ico-smiley',
                    'ico-smiley2',
                    'ico-tongue',
                    'ico-tongue2',
                    'ico-sad',
                    'ico-sad2',
                    'ico-wink',
                    'ico-wink2',
                    'ico-grin',
                    'ico-grin2',
                    'ico-cool',
                    'ico-cool2',
                    'ico-angry',
                    'ico-angry2',
                    'ico-evil',
                    'ico-evil2',
                    'ico-shocked',
                    'ico-shocked2',
                    'ico-confused',
                    'ico-confused2',
                    'ico-neutral',
                    'ico-neutral2',
                    'ico-wondering',
                    'ico-wondering2',
                    'ico-cursor',
                    'ico-cursor2',
                    'ico-point-up',
                    'ico-point-right',
                    'ico-point-down',
                    'ico-point-left',
                    'ico-pointer',
                    'ico-hand',
                    'ico-stack-empty',
                    'ico-stack-plus',
                    'ico-stack-minus',
                    'ico-stack-star',
                    'ico-stack-picture',
                    'ico-stack-down',
                    'ico-stack-up',
                    'ico-stack-cancel',
                    'ico-stack-checkmark',
                    'ico-stack-list',
                    'ico-stack-clubs',
                    'ico-stack-spades',
                    'ico-stack-hearts',
                    'ico-stack-diamonds',
                    'ico-stack-user',
                    'ico-stack4',
                    'ico-stack-music',
                    'ico-stack-play',
                    'ico-move2',
                    'ico-resize',
                    'ico-resize2',
                    'ico-warning',
                    'ico-warning2',
                    'ico-notification',
                    'ico-notification2',
                    'ico-question2',
                    'ico-question22',
                    'ico-question3',
                    'ico-question4',
                    'ico-question5',
                    'ico-plus-circle',
                    'ico-plus-circle2',
                    'ico-minus-circle',
                    'ico-minus-circle2',
                    'ico-info2',
                    'ico-info22',
                    'ico-blocked',
                    'ico-cancel-circle',
                    'ico-cancel-circle2',
                    'ico-checkmark-circle',
                    'ico-checkmark-circle2',
                    'ico-cancel',
                    'ico-close',
                    'ico-close2',
                    'ico-close3',
                    'ico-close4',
                    'ico-checkmark',
                    'ico-checkmark2',
                    'ico-checkmark3',
                    'ico-checkmark4',
                    'ico-spell-check',
                    'ico-minus2',
                    'ico-plus2',
                    'ico-minus22',
                    'ico-plus22',
                    'ico-enter',
                    'ico-exit',
                    'ico-enter2',
                    'ico-exit2',
                    'ico-enter3',
                    'ico-exit3',
                    'ico-exit4',
                    'ico-play32',
                    'ico-pause2',
                    'ico-stop2',
                    'ico-backward2',
                    'ico-forward22',
                    'ico-play4',
                    'ico-pause22',
                    'ico-stop22',
                    'ico-backward22',
                    'ico-forward3',
                    'ico-first',
                    'ico-last',
                    'ico-previous',
                    'ico-next',
                    'ico-eject2',
                    'ico-volume-high',
                    'ico-volume-medium',
                    'ico-volume-low',
                    'ico-volume-mute',
                    'ico-volume-mute2',
                    'ico-volume-increase',
                    'ico-volume-decrease',
                    'ico-volume-high2',
                    'ico-volume-medium2',
                    'ico-volume-low2',
                    'ico-volume-mute3',
                    'ico-volume-mute4',
                    'ico-volume-increase2',
                    'ico-volume-decrease2',
                    'ico-volume5',
                    'ico-volume4',
                    'ico-volume3',
                    'ico-volume2',
                    'ico-volume1',
                    'ico-volume0',
                    'ico-volume-mute5',
                    'ico-volume-mute6',
                    'ico-loop',
                    'ico-loop2',
                    'ico-loop3',
                    'ico-loop4',
                    'ico-loop5',
                    'ico-shuffle',
                    'ico-shuffle2',
                    'ico-wave',
                    'ico-wave2',
                    'ico-arrow-first',
                    'ico-arrow-right2',
                    'ico-arrow-up2',
                    'ico-arrow-right22',
                    'ico-arrow-down2',
                    'ico-arrow-left2',
                    'ico-arrow-up22',
                    'ico-arrow-right3',
                    'ico-arrow-down22',
                    'ico-arrow-left22',
                    'ico-arrow-up-left',
                    'ico-arrow-up3',
                    'ico-arrow-up-right',
                    'ico-arrow-right4',
                    'ico-arrow-down-right',
                    'ico-arrow-down3',
                    'ico-arrow-down-left',
                    'ico-arrow-left3',
                    'ico-arrow-up-left2',
                    'ico-arrow-up4',
                    'ico-arrow-up-right2',
                    'ico-arrow-right5',
                    'ico-arrow-down-right2',
                    'ico-arrow-down4',
                    'ico-arrow-down-left2',
                    'ico-arrow-left4',
                    'ico-arrow-up-left3',
                    'ico-arrow-up5',
                    'ico-arrow-up-right3',
                    'ico-arrow-right6',
                    'ico-arrow-down-right3',
                    'ico-arrow-down5',
                    'ico-arrow-down-left3',
                    'ico-arrow-left5',
                    'ico-arrow-up-left4',
                    'ico-arrow-up6',
                    'ico-arrow-up-right4',
                    'ico-arrow-right7',
                    'ico-arrow-down-right4',
                    'ico-arrow-down6',
                    'ico-arrow-down-left4',
                    'ico-arrow-left6',
                    'ico-arrow',
                    'ico-arrow2',
                    'ico-arrow3',
                    'ico-arrow4',
                    'ico-arrow5',
                    'ico-arrow6',
                    'ico-arrow7',
                    'ico-arrow8',
                    'ico-arrow-up-left5',
                    'ico-arrow-square',
                    'ico-arrow-up-right5',
                    'ico-arrow-right8',
                    'ico-arrow-down-right5',
                    'ico-arrow-down7',
                    'ico-arrow-down-left5',
                    'ico-arrow-left7',
                    'ico-arrow-up7',
                    'ico-arrow-right9',
                    'ico-arrow-down8',
                    'ico-arrow-left8',
                    'ico-arrow-up8',
                    'ico-arrow-right10',
                    'ico-arrow-bottom',
                    'ico-arrow-left9',
                    'ico-arrow-up-left6',
                    'ico-arrow-up9',
                    'ico-arrow-up-right6',
                    'ico-arrow-right11',
                    'ico-arrow-down-right6',
                    'ico-arrow-down9',
                    'ico-arrow-down-left6',
                    'ico-arrow-left10',
                    'ico-arrow-up-left7',
                    'ico-arrow-up10',
                    'ico-arrow-up-right7',
                    'ico-arrow-right12',
                    'ico-arrow-down-right7',
                    'ico-arrow-down10',
                    'ico-arrow-down-left7',
                    'ico-arrow-left11',
                    'ico-arrow-up11',
                    'ico-arrow-right13',
                    'ico-arrow-down11',
                    'ico-arrow-left12',
                    'ico-arrow-up12',
                    'ico-arrow-right14',
                    'ico-arrow-down12',
                    'ico-arrow-left13',
                    'ico-arrow-up13',
                    'ico-arrow-right15',
                    'ico-arrow-down13',
                    'ico-arrow-left14',
                    'ico-arrow-up14',
                    'ico-arrow-right16',
                    'ico-arrow-down14',
                    'ico-arrow-left15',
                    'ico-arrow-up15',
                    'ico-arrow-right17',
                    'ico-arrow-down15',
                    'ico-arrow-left16',
                    'ico-arrow-up16',
                    'ico-arrow-right18',
                    'ico-arrow-down16',
                    'ico-arrow-left17',
                    'ico-menu10',
                    'ico-menu11',
                    'ico-menu-close',
                    'ico-menu-close2',
                    'ico-enter4',
                    'ico-enter5',
                    'ico-esc',
                    'ico-backspace',
                    'ico-backspace2',
                    'ico-backspace3',
                    'ico-tab',
                    'ico-transmission',
                    'ico-transmission2',
                    'ico-sort2',
                    'ico-sort22',
                    'ico-key-keyboard',
                    'ico-key-A',
                    'ico-key-up',
                    'ico-key-right',
                    'ico-key-down',
                    'ico-key-left',
                    'ico-command',
                    'ico-checkbox-checked',
                    'ico-checkbox-unchecked',
                    'ico-square',
                    'ico-checkbox-partial',
                    'ico-checkbox',
                    'ico-checkbox-unchecked2',
                    'ico-checkbox-partial2',
                    'ico-checkbox-checked2',
                    'ico-checkbox-unchecked3',
                    'ico-checkbox-partial3',
                    'ico-radio-checked',
                    'ico-radio-unchecked',
                    'ico-circle2',
                    'ico-circle22',
                    'ico-crop2',
                    'ico-crop22',
                    'ico-vector',
                    'ico-rulers',
                    'ico-scissors',
                    'ico-scissors2',
                    'ico-scissors3',
                    'ico-filter2',
                    'ico-filter22',
                    'ico-filter3',
                    'ico-filter4',
                    'ico-font2',
                    'ico-font-size',
                    'ico-type',
                    'ico-text-height2',
                    'ico-text-width2',
                    'ico-height',
                    'ico-width',
                    'ico-bold2',
                    'ico-underline2',
                    'ico-italic2',
                    'ico-strikethrough2',
                    'ico-strikethrough22',
                    'ico-font-size2',
                    'ico-bold22',
                    'ico-underline22',
                    'ico-italic22',
                    'ico-strikethrough3',
                    'ico-omega',
                    'ico-sigma',
                    'ico-nbsp',
                    'ico-page-break',
                    'ico-page-break2',
                    'ico-superscript2',
                    'ico-subscript2',
                    'ico-superscript22',
                    'ico-subscript22',
                    'ico-text-color',
                    'ico-highlight',
                    'ico-pagebreak',
                    'ico-clear-formatting',
                    'ico-table2',
                    'ico-table22',
                    'ico-insert-template',
                    'ico-pilcrow',
                    'ico-left-toright',
                    'ico-right-toleft',
                    'ico-paragraph-left',
                    'ico-paragraph-center',
                    'ico-paragraph-right',
                    'ico-paragraph-justify',
                    'ico-paragraph-left2',
                    'ico-paragraph-center2',
                    'ico-paragraph-right2',
                    'ico-paragraph-justify2',
                    'ico-indent-increase',
                    'ico-indent-decrease',
                    'ico-paragraph-left3',
                    'ico-paragraph-center3',
                    'ico-paragraph-right3',
                    'ico-paragraph-justify3',
                    'ico-share2',
                    'ico-new-tab',
                    'ico-new-tab2',
                    'ico-popout',
                    'ico-embed',
                    'ico-code2',
                    'ico-console',
                    'ico-seven-segment0',
                    'ico-seven-segment1',
                    'ico-seven-segment2',
                    'ico-seven-segment3',
                    'ico-seven-segment4',
                    'ico-seven-segment5',
                    'ico-seven-segment6',
                    'ico-seven-segment7',
                    'ico-seven-segment8',
                    'ico-seven-segment9',
                    'ico-share22',
                    'ico-share3',
                    'ico-mail',
                    'ico-mail2',
                    'ico-mail3',
                    'ico-mail4',
                    'ico-google',
                    'ico-google-plus2',
                    'ico-google-plus22',
                    'ico-google-plus3',
                    'ico-google-plus4',
                    'ico-google-drive',
                    'ico-facebook2',
                    'ico-facebook22',
                    'ico-facebook3',
                    'ico-facebook4',
                    'ico-instagram2',
                    'ico-twitter2',
                    'ico-twitter22',
                    'ico-twitter3',
                    'ico-feed2',
                    'ico-feed3',
                    'ico-feed4',
                    'ico-youtube2',
                    'ico-youtube22',
                    'ico-vimeo',
                    'ico-vimeo2',
                    'ico-vimeo3',
                    'ico-lanyrd',
                    'ico-flickr2',
                    'ico-flickr22',
                    'ico-flickr3',
                    'ico-flickr4',
                    'ico-picassa',
                    'ico-picassa2',
                    'ico-dribbble2',
                    'ico-dribbble22',
                    'ico-dribbble3',
                    'ico-forrst',
                    'ico-forrst2',
                    'ico-deviantart',
                    'ico-deviantart2',
                    'ico-steam',
                    'ico-steam2',
                    'ico-github2',
                    'ico-github22',
                    'ico-github3',
                    'ico-github4',
                    'ico-github5',
                    'ico-wordpress',
                    'ico-wordpress2',
                    'ico-joomla',
                    'ico-blogger',
                    'ico-blogger2',
                    'ico-tumblr2',
                    'ico-tumblr22',
                    'ico-yahoo',
                    'ico-tux',
                    'ico-apple2',
                    'ico-finder',
                    'ico-android2',
                    'ico-windows2',
                    'ico-windows8',
                    'ico-soundcloud',
                    'ico-soundcloud2',
                    'ico-skype2',
                    'ico-reddit',
                    'ico-linkedin2',
                    'ico-lastfm',
                    'ico-lastfm2',
                    'ico-delicious',
                    'ico-stumbleupon',
                    'ico-stumbleupon2',
                    'ico-stackoverflow',
                    'ico-pinterest2',
                    'ico-pinterest22',
                    'ico-xing2',
                    'ico-xing22',
                    'ico-flattr',
                    'ico-foursquare2',
                    'ico-foursquare22',
                    'ico-paypal',
                    'ico-paypal2',
                    'ico-paypal3',
                    'ico-yelp',
                    'ico-libreoffice',
                    'ico-file-pdf',
                    'ico-file-openoffice',
                    'ico-file-word',
                    'ico-file-excel',
                    'ico-file-zip',
                    'ico-file-powerpoint',
                    'ico-file-xml',
                    'ico-file-css',
                    'ico-html52',
                    'ico-html522',
                    'ico-css32',
                    'ico-chrome',
                    'ico-firefox',
                    'ico-IE',
                    'ico-opera',
                    'ico-safari',
                    'ico-IcoMoon',
                    'ico-indent-decrease2',
                    'ico-indent-decrease3',
                    'ico-indent-increase2',
                    'ico-indent-increase22',
                ],
                icon_arr3:[
                    'ti-arrow-up',
                    'ti-arrow-right',
                    'ti-arrow-left',
                    'ti-arrow-down',
                    'ti-arrows-vertical',
                    'ti-arrows-horizontal',
                    'ti-angle-up',
                    'ti-angle-right',
                    'ti-angle-left',
                    'ti-angle-down',
                    'ti-angle-double-up',
                    'ti-angle-double-right',
                    'ti-angle-double-left',
                    'ti-angle-double-down',
                    'ti-move',
                    'ti-fullscreen',
                    'ti-arrow-top-right',
                    'ti-arrow-top-left',
                    'ti-arrow-circle-up',
                    'ti-arrow-circle-right',
                    'ti-arrow-circle-left',
                    'ti-arrow-circle-down',
                    'ti-arrows-corner',
                    'ti-split-v',
                    'ti-split-v-alt',
                    'ti-split-h',
                    'ti-hand-point-up',
                    'ti-hand-point-right',
                    'ti-hand-point-left',
                    'ti-hand-point-down',
                    'ti-back-right',
                    'ti-back-left',
                    'ti-exchange-vertical',
                    'ti-wand',
                    'ti-save',
                    'ti-save-alt',
                    'ti-direction',
                    'ti-direction-alt',
                    'ti-user',
                    'ti-link',
                    'ti-unlink',
                    'ti-trash',
                    'ti-target',
                    'ti-tag',
                    'ti-desktop',
                    'ti-tablet',
                    'ti-mobile',
                    'ti-email',
                    'ti-star',
                    'ti-spray',
                    'ti-signal',
                    'ti-shopping-cart',
                    'ti-shopping-cart-full',
                    'ti-settings',
                    'ti-search',
                    'ti-zoom-in',
                    'ti-zoom-out',
                    'ti-cut',
                    'ti-ruler',
                    'ti-ruler-alt-2',
                    'ti-ruler-pencil',
                    'ti-ruler-alt',
                    'ti-bookmark',
                    'ti-bookmark-alt',
                    'ti-reload',
                    'ti-plus',
                    'ti-minus',
                    'ti-close',
                    'ti-pin',
                    'ti-pencil',
                    'ti-pencil-alt',
                    'ti-paint-roller',
                    'ti-paint-bucket',
                    'ti-na',
                    'ti-medall',
                    'ti-medall-alt',
                    'ti-marker',
                    'ti-marker-alt',
                    'ti-lock',
                    'ti-unlock',
                    'ti-location-arrow',
                    'ti-layout',
                    'ti-layers',
                    'ti-layers-alt',
                    'ti-key',
                    'ti-image',
                    'ti-heart',
                    'ti-heart-broken',
                    'ti-hand-stop',
                    'ti-hand-open',
                    'ti-hand-drag',
                    'ti-flag',
                    'ti-flag-alt',
                    'ti-flag-alt-2',
                    'ti-eye',
                    'ti-import',
                    'ti-export',
                    'ti-cup',
                    'ti-crown',
                    'ti-comments',
                    'ti-comment',
                    'ti-comment-alt',
                    'ti-thought',
                    'ti-clip',
                    'ti-check',
                    'ti-check-box',
                    'ti-camera',
                    'ti-announcement',
                    'ti-brush',
                    'ti-brush-alt',
                    'ti-palette',
                    'ti-briefcase',
                    'ti-bolt',
                    'ti-bolt-alt',
                    'ti-blackboard',
                    'ti-bag',
                    'ti-world',
                    'ti-wheelchair',
                    'ti-car',
                    'ti-truck',
                    'ti-timer',
                    'ti-ticket',
                    'ti-thumb-up',
                    'ti-thumb-down',
                    'ti-stats-up',
                    'ti-stats-down',
                    'ti-shine',
                    'ti-shift-right',
                    'ti-shift-left',
                    'ti-shift-right-alt',
                    'ti-shift-left-alt',
                    'ti-shield',
                    'ti-notepad',
                    'ti-server',
                    'ti-pulse',
                    'ti-printer',
                    'ti-power-off',
                    'ti-plug',
                    'ti-pie-chart',
                    'ti-panel',
                    'ti-package',
                    'ti-music',
                    'ti-music-alt',
                    'ti-mouse',
                    'ti-mouse-alt',
                    'ti-money',
                    'ti-microphone',
                    'ti-menu',
                    'ti-menu-alt',
                    'ti-map',
                    'ti-map-alt',
                    'ti-location-pin',
                    'ti-light-bulb',
                    'ti-info',
                    'ti-infinite',
                    'ti-id-badge',
                    'ti-hummer',
                    'ti-home',
                    'ti-help',
                    'ti-headphone',
                    'ti-harddrives',
                    'ti-harddrive',
                    'ti-gift',
                    'ti-game',
                    'ti-filter',
                    'ti-files',
                    'ti-file',
                    'ti-zip',
                    'ti-folder',
                    'ti-envelope',
                    'ti-dashboard',
                    'ti-cloud',
                    'ti-cloud-up',
                    'ti-cloud-down',
                    'ti-clipboard',
                    'ti-calendar',
                    'ti-book',
                    'ti-bell',
                    'ti-basketball',
                    'ti-bar-chart',
                    'ti-bar-chart-alt',
                    'ti-archive',
                    'ti-anchor',
                    'ti-alert',
                    'ti-alarm-clock',
                    'ti-agenda',
                    'ti-write',
                    'ti-wallet',
                    'ti-video-clapper',
                    'ti-video-camera',
                    'ti-vector',
                    'ti-support',
                    'ti-stamp',
                    'ti-slice',
                    'ti-shortcode',
                    'ti-receipt',
                    'ti-pin2',
                    'ti-pin-alt',
                    'ti-pencil-alt2',
                    'ti-eraser',
                    'ti-more',
                    'ti-more-alt',
                    'ti-microphone-alt',
                    'ti-magnet',
                    'ti-line-double',
                    'ti-line-dotted',
                    'ti-line-dashed',
                    'ti-ink-pen',
                    'ti-info-alt',
                    'ti-help-alt',
                    'ti-headphone-alt',
                    'ti-gallery',
                    'ti-face-smile',
                    'ti-face-sad',
                    'ti-credit-card',
                    'ti-comments-smiley',
                    'ti-time',
                    'ti-share',
                    'ti-share-alt',
                    'ti-rocket',
                    'ti-new-window',
                    'ti-rss',
                    'ti-rss-alt',
                    'ti-control-stop',
                    'ti-control-shuffle',
                    'ti-control-play',
                    'ti-control-pause',
                    'ti-control-forward',
                    'ti-control-backward',
                    'ti-volume',
                    'ti-control-skip-forward',
                    'ti-control-skip-backward',
                    'ti-control-record',
                    'ti-control-eject',
                    'ti-paragraph',
                    'ti-uppercase',
                    'ti-underline',
                    'ti-text',
                    'ti-Italic',
                    'ti-smallcap',
                    'ti-list',
                    'ti-list-ol',
                    'ti-align-right',
                    'ti-align-left',
                    'ti-align-justify',
                    'ti-align-center',
                    'ti-quote-right',
                    'ti-quote-left',
                    'ti-layout-width-full',
                    'ti-layout-width-default',
                    'ti-layout-width-default-alt',
                    'ti-layout-tab',
                    'ti-layout-tab-window',
                    'ti-layout-tab-v',
                    'ti-layout-tab-min',
                    'ti-layout-slider',
                    'ti-layout-slider-alt',
                    'ti-layout-sidebar-right',
                    'ti-layout-sidebar-none',
                    'ti-layout-sidebar-left',
                    'ti-layout-placeholder',
                    'ti-layout-menu',
                    'ti-layout-menu-v',
                    'ti-layout-menu-separated',
                    'ti-layout-menu-full',
                    'ti-layout-media-right',
                    'ti-layout-media-right-alt',
                    'ti-layout-media-overlay',
                    'ti-layout-media-overlay-alt',
                    'ti-layout-media-overlay-alt-2',
                    'ti-layout-media-left',
                    'ti-layout-media-left-alt',
                    'ti-layout-media-center',
                    'ti-layout-media-center-alt',
                    'ti-layout-list-thumb',
                    'ti-layout-list-thumb-alt',
                    'ti-layout-list-post',
                    'ti-layout-list-large-image',
                    'ti-layout-line-solid',
                    'ti-layout-grid4',
                    'ti-layout-grid3',
                    'ti-layout-grid2',
                    'ti-layout-grid2-thumb',
                    'ti-layout-cta-right',
                    'ti-layout-cta-left',
                    'ti-layout-cta-center',
                    'ti-layout-cta-btn-right',
                    'ti-layout-cta-btn-left',
                    'ti-layout-column4',
                    'ti-layout-column3',
                    'ti-layout-column2',
                    'ti-layout-accordion-separated',
                    'ti-layout-accordion-merged',
                    'ti-layout-accordion-list',
                    'ti-widgetized',
                    'ti-widget',
                    'ti-widget-alt',
                    'ti-view-list',
                    'ti-view-list-alt',
                    'ti-view-grid',
                    'ti-upload',
                    'ti-download',
                    'ti-loop',
                    'ti-layout-sidebar-2',
                    'ti-layout-grid4-alt',
                    'ti-layout-grid3-alt',
                    'ti-layout-grid2-alt',
                    'ti-layout-column4-alt',
                    'ti-layout-column3-alt',
                    'ti-layout-column2-alt',
                    'ti-flickr',
                    'ti-flickr-alt',
                    'ti-instagram',
                    'ti-google',
                    'ti-github',
                    'ti-facebook',
                    'ti-dropbox',
                    'ti-dropbox-alt',
                    'ti-dribbble',
                    'ti-apple',
                    'ti-android',
                    'ti-yahoo',
                    'ti-trello',
                    'ti-stack-overflow',
                    'ti-soundcloud',
                    'ti-sharethis',
                    'ti-sharethis-alt',
                    'ti-reddit',
                    'ti-microsoft',
                    'ti-microsoft-alt',
                    'ti-linux',
                    'ti-jsfiddle',
                    'ti-joomla',
                    'ti-html5',
                    'ti-css3',
                    'ti-drupal',
                    'ti-wordpress',
                    'ti-tumblr',
                    'ti-tumblr-alt',
                    'ti-skype',
                    'ti-youtube',
                    'ti-vimeo',
                    'ti-vimeo-alt',
                    'ti-twitter',
                    'ti-twitter-alt',
                    'ti-linkedin',
                    'ti-pinterest',
                    'ti-pinterest-alt',
                    'ti-themify-logo',
                    'ti-themify-favicon',
                    'ti-themify-favicon-alt',
                ],
                icon_arr4:[
                    'f-i-activity',
                    'f-i-airplay',
                    'f-i-alert-circle',
                    'f-i-alert-octagon',
                    'f-i-alert-triangle',
                    'f-i-align-center',
                    'f-i-align-justify',
                    'f-i-align-left',
                    'f-i-align-right',
                    'f-i-anchor',
                    'f-i-aperture',
                    'f-i-arrow-down',
                    'f-i-arrow-down-left',
                    'f-i-arrow-down-right',
                    'f-i-arrow-left',
                    'f-i-arrow-right',
                    'f-i-arrow-up',
                    'f-i-arrow-up-left',
                    'f-i-arrow-up-right',
                    'f-i-at-sign',
                    'f-i-award',
                    'f-i-bar-chart',
                    'f-i-bar-chart-2',
                    'f-i-battery',
                    'f-i-battery-charging',
                    'f-i-bell',
                    'f-i-bell-off',
                    'f-i-bluetooth',
                    'f-i-bold',
                    'f-i-book',
                    'f-i-bookmark',
                    'f-i-box',
                    'f-i-briefcase',
                    'f-i-calendar',
                    'f-i-camera',
                    'f-i-camera-off',
                    'f-i-cast',
                    'f-i-check',
                    'f-i-check-circle',
                    'f-i-check-square',
                    'f-i-chevron-down',
                    'f-i-chevron-left',
                    'f-i-chevron-right',
                    'f-i-chevron-up',
                    'f-i-chevrons-down',
                    'f-i-chevrons-left',
                    'f-i-chevrons-right',
                    'f-i-chevrons-up',
                    'f-i-chrome',
                    'f-i-circle',
                    'f-i-clipboard',
                    'f-i-clock',
                    'f-i-cloud',
                    'f-i-cloud-drizzle',
                    'f-i-cloud-lightning',
                    'f-i-cloud-off',
                    'f-i-cloud-rain',
                    'f-i-cloud-snow',
                    'f-i-codepen',
                    'f-i-command',
                    'f-i-compass',
                    'f-i-copy',
                    'f-i-corner-down-left',
                    'f-i-corner-down-right',
                    'f-i-corner-left-down',
                    'f-i-corner-left-up',
                    'f-i-corner-right-down',
                    'f-i-corner-right-up',
                    'f-i-corner-up-left',
                    'f-i-corner-up-right',
                    'f-i-cpu',
                    'f-i-credit-card',
                    'f-i-crop',
                    'f-i-crosshair',
                    'f-i-delete',
                    'f-i-disc',
                    'f-i-download',
                    'f-i-download-cloud',
                    'f-i-droplet',
                    'f-i-edit',
                    'f-i-edit-2',
                    'f-i-edit-3',
                    'f-i-external-link',
                    'f-i-eye',
                    'f-i-eye-off',
                    'f-i-facebook',
                    'f-i-fast-forward',
                    'f-i-feather',
                    'f-i-file',
                    'f-i-file-minus',
                    'f-i-file-plus',
                    'f-i-file-text',
                    'f-i-film',
                    'f-i-filter',
                    'f-i-flag',
                    'f-i-folder',
                    'f-i-github',
                    'f-i-gitlab',
                    'f-i-globe',
                    'f-i-grid',
                    'f-i-hash',
                    'f-i-headphones',
                    'f-i-heart',
                    'f-i-help-circle',
                    'f-i-home',
                    'f-i-image',
                    'f-i-inbox',
                    'f-i-info',
                    'f-i-instagram',
                    'f-i-italic',
                    'f-i-layers',
                    'f-i-layout',
                    'f-i-life-buoy',
                    'f-i-link',
                    'f-i-link-2',
                    'f-i-list',
                    'f-i-loader',
                    'f-i-lock',
                    'f-i-log-in',
                    'f-i-log-out',
                    'f-i-mail',
                    'f-i-map',
                    'f-i-map-pin',
                    'f-i-maximize',
                    'f-i-maximize-2',
                    'f-i-menu',
                    'f-i-message-circle',
                    'f-i-message-square',
                    'f-i-mic',
                    'f-i-mic-off',
                    'f-i-minimize',
                    'f-i-minimize-2',
                    'f-i-minus',
                    'f-i-minus-circle',
                    'f-i-minus-square',
                    'f-i-monitor',
                    'f-i-moon',
                    'f-i-more-horizontal',
                    'f-i-more-vertical',
                    'f-i-move',
                    'f-i-music',
                    'f-i-navigation',
                    'f-i-navigation-2',
                    'f-i-octagon',
                    'f-i-package',
                    'f-i-paperclip',
                    'f-i-pause',
                    'f-i-pause-circle',
                    'f-i-percent',
                    'f-i-phone',
                    'f-i-phone-call',
                    'f-i-phone-forwarded',
                    'f-i-phone-incoming',
                    'f-i-phone-missed',
                    'f-i-phone-off',
                    'f-i-phone-outgoing',
                    'f-i-pie-chart',
                    'f-i-play',
                    'f-i-play-circle',
                    'f-i-plus',
                    'f-i-plus-circle',
                    'f-i-plus-square',
                    'f-i-pocket',
                    'f-i-power',
                    'f-i-printer',
                    'f-i-radio',
                    'f-i-refresh-ccw',
                    'f-i-refresh-cw',
                    'f-i-repeat',
                    'f-i-rewind',
                    'f-i-rotate-ccw',
                    'f-i-rotate-cw',
                    'f-i-save',
                    'f-i-scissors',
                    'f-i-search',
                    'f-i-server',
                    'f-i-settings',
                    'f-i-share',
                    'f-i-share-2',
                    'f-i-shield',
                    'f-i-shopping-cart',
                    'f-i-shuffle',
                    'f-i-sidebar',
                    'f-i-skip-back',
                    'f-i-skip-forward',
                    'f-i-slack',
                    'f-i-slash',
                    'f-i-sliders',
                    'f-i-smartphone',
                    'f-i-speaker',
                    'f-i-square',
                    'f-i-star',
                    'f-i-stop-circle',
                    'f-i-sun',
                    'f-i-sunrise',
                    'f-i-sunset',
                    'f-i-tablet',
                    'f-i-tag',
                    'f-i-target',
                    'f-i-thermometer',
                    'f-i-thumbs-down',
                    'f-i-thumbs-up',
                    'f-i-toggle-left',
                    'f-i-toggle-right',
                    'f-i-trash',
                    'f-i-trash-2',
                    'f-i-trending-down',
                    'f-i-trending-up',
                    'f-i-triangle',
                    'f-i-tv',
                    'f-i-twitter',
                    'f-i-type',
                    'f-i-umbrella',
                    'f-i-underline',
                    'f-i-unlock',
                    'f-i-upload',
                    'f-i-upload-cloud',
                    'f-i-user',
                    'f-i-user-check',
                    'f-i-user-minus',
                    'f-i-user-plus',
                    'f-i-user-x',
                    'f-i-users',
                    'f-i-video',
                    'f-i-video-off',
                    'f-i-voicemail',
                    'f-i-volume',
                    'f-i-volume-1',
                    'f-i-volume-2',
                    'f-i-volume-x',
                    'f-i-watch',
                    'f-i-wifi',
                    'f-i-wifi-off',
                    'f-i-wind',
                    'f-i-x',
                    'f-i-x-circle',
                    'f-i-x-square',
                    'f-i-zap',
                    'f-i-zoom-in',
                    'f-i-zoom-out',
                ]
            }
        },
        methods:{},
        mounted(){
          this.$parent.main_header_active = false;
        },
        created(){
            this.$parent.routerLoading();
        },
    }
</script>
<style scoped>
    .icon-title{
        line-height: 2rem;
        font-size: 1.25rem;
        font-weight: 600;
        color: #333;
        margin-bottom: 1rem;
    }
    .icon ul{
        list-style: none;
        padding: 0;
        margin: 0 0 1.25rem;
    }
    .icon ul::after{
        content: '';
        display: block;
        width: 0;
        height: 0;
        clear: both;
    }
    .icon li{
        width: 118px;
        height: 148px;
        float: left;
        border: 1px solid #ddd;
        padding: 0;
        margin: -1px 0 0 -1px;
    }
    .icon li > i{
        width: 118px;
        height: 118px;
        text-align: center;
        line-height: 100px;
        font-size: 30px;
        display: block;
    }
    .icon li > i > i{
        width: 50px;
        height: 50px;
        vertical-align: middle;
        display: inline-block;
        line-height: 50px;
    }
    .icon li > span{
        display: block;
        width: 100%;
        height: 30px;
        font-size: 8px;
        text-align: center;
        line-height: 30px;
        color: var(--dark);
    }
</style>


// WEBPACK FOOTER //
// src/components/main-content/icon.vue